import { Main } from "@/components/Main";
import { If } from "@/components/If";
import { usePermissions } from "@/hooks/usePermissions";
import { SellersReceived } from "@/App/Distributions/SellersReceived";

export const PageList = () => {
  const { hasPermission } = usePermissions();

  return (
    <Main>
      <If condition={hasPermission("view-distributions-list")}>
        <SellersReceived />
      </If>
    </Main>
  );
};
